const fullscreenRoutes = [
  "/signup",
  "/order-consolidation",
  "/order-consolidation/:shipmentId/edit",
  "/quotation/quick-approval",
  "/document-parser",
];

export default fullscreenRoutes;
